import config from "../../config/config";
import axios from "axios";
import { getToken } from "../../common";

export const buyerLotsSummaryAPI = async (eventId, buyerId) => {
  return await axios({
    method: "get",
    url: `${config.api.base_url}dashboard/events/${eventId}/buyers/${buyerId}`,
    //params    : params,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });
};

export default buyerLotsSummaryAPI;
